var _path, _path2, _path3, _path4, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentZip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 22,
    viewBox: "0 0 36 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.76289 13.7717L4.02305 15.866H13.1313L12.8332 13.4676H8.58633L8.54922 13.1704L12.4605 10.4698L12.1992 8.3717H3.0918L3.38984 10.7697H7.64375L7.68086 11.0696L3.76289 13.7717Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2573 8.3717L14.189 15.866H23.3038L22.3722 8.3717H13.2573Z",
    fill: "#AA8FFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8621 11.0696C32.652 9.38528 31.3129 8.36441 29.4926 8.37174H23.4297L24.3609 15.8664H27.0887L26.902 14.3673H29.7883C32.0598 14.3669 33.0992 12.9686 32.8621 11.0696ZM29.4934 12.2661L26.6418 12.2692L26.4184 10.4706L29.2859 10.4729C29.9602 10.481 30.3051 10.8562 30.3609 11.3695C30.3953 11.6999 30.2422 12.2657 29.4934 12.2657V12.2661Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9808 7.37595C16.4605 6.86711 16.3769 6.01972 15.7941 5.48326C15.2112 4.9468 14.3498 4.92441 13.8701 5.43325C13.3904 5.94209 13.474 6.78947 14.0569 7.32594C14.6397 7.8624 15.5011 7.88479 15.9808 7.37595Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 35.5,
    height: 21.5,
    rx: 1.75,
    stroke: "#C4C4C4",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentZip);
export default __webpack_public_path__ + "static/media/payment-zip.e209b1d5543e4540bc63b5e90b2717fd.svg";
export { ForwardRef as ReactComponent };